export default "__VITE_ASSET__CfnfglmH__"